import React, { createContext, useState, ReactNode, useEffect } from 'react';

interface SidebarContextProps {
  toggleMenu: boolean;
  openMenu: () => void;
  isSidebarCollapsed: boolean;
  toggleSidebar: () => void;
  selectedFilters: boolean;
  resetSelectedFilters: () => void;
}

const defaultValue: SidebarContextProps = {
  toggleMenu: false,
  openMenu: () => {},
  isSidebarCollapsed: false,
  toggleSidebar: () => {},
  selectedFilters: false,
  resetSelectedFilters: () => {},
};

export const SidebarContext = createContext<SidebarContextProps>(defaultValue);

interface SidebarProviderProps {
  children: ReactNode;
}

export const SidebarProvider: React.FC<SidebarProviderProps> = ({ children }) => {
  const [selectedFilters, setSelectedFilters] = useState(false);
  const [toggleMenu, setToggleMenu] = useState(false);
  const [isSidebarCollapsed, setIsSidebarCollapsed] = useState(false);

  const resetSelectedFilters = () => {
    setSelectedFilters(true); // Reset filters when route changes
    setTimeout(() => {
      setSelectedFilters(false); // Reset to false after a delay
    }, 100);
  };

  const toggleSidebar = () => {
    setIsSidebarCollapsed((prevState) => {
      console.log('Sidebar state toggled:', !prevState);
      return !prevState;
    });
  };
  
  useEffect(() => {
    console.log('isSidebarCollapsed updated:', isSidebarCollapsed);
  }, [isSidebarCollapsed]);
  const openMenu = () => {
    setToggleMenu(!toggleMenu);
  };

  return (
    <SidebarContext.Provider
      value={{
        toggleMenu,
        openMenu,
        isSidebarCollapsed,
        toggleSidebar,
        selectedFilters,
        resetSelectedFilters,
      }}
    >
      {children}
    </SidebarContext.Provider>
  );
};
